/**
 * Geodaten eines Katalog-Datensatzes als Zeilen (Merkmale + `geometry` als GeoJSON) fuer Karten-Kacheln.
 *
 * - In der App (angemeldet): ueber die Datenabfrage (geo-features-app.ts), damit auch interne Datensaetze gehen.
 * - Oeffentlich: baut der Katalog dieselbe Abfrage selbst (/oeffentlich/kacheln/<id>/daten, lib/public-tiles.ts).
 */
import type { DatasetSummary } from './api.js';

export type GeoRow = Record<string, unknown> & { geometry: unknown };

const IDENT = /^[a-zA-Z_][a-zA-Z0-9_]*$/u;
const GEO_TYPE = /^(geometry|geography|point)\b|^geometry\(/iu;

export function geoColumn(d: Pick<DatasetSummary, 'schema_def'>): string | null {
  return d.schema_def?.columns?.find((c) => GEO_TYPE.test(String(c.type)))?.name ?? null;
}

/** Geodaten-Abfrage fuer einen Datensatz; null, wenn er keine Geometriespalte in einer SQL-Ablage hat. */
export function geoSql(d: Pick<DatasetSummary, 'silo' | 'silo_location' | 'schema_def'>, limit: number): string | null {
  const geo = geoColumn(d);
  const table = d.silo_location.split('.');
  if (!geo || !IDENT.test(geo) || table.length !== 2 || !table.every((t) => IDENT.test(t))) return null;
  if (d.silo !== 'postgis' && d.silo !== 'relational' && d.silo !== 'timescale') return null;
  const andere = d.schema_def.columns
    .map((c) => c.name)
    .filter((n) => n !== geo && IDENT.test(n))
    .map((n) => `"${n}"`);
  const n = Math.max(1, Math.min(10000, Math.floor(limit)));
  return `SELECT ${[...andere, `ST_AsGeoJSON("${geo}", 7) AS geometry`].join(', ')} FROM "${table[0]}"."${table[1]}" WHERE "${geo}" IS NOT NULL LIMIT ${n}`;
}
